import { jsonrepair } from 'jsonrepair';

// jsonrepair can corrupt valid JSON (e.g. "[" inside an array string), so only malformed input reaches it.
export function parseJsonOrRepair(text: string): ReturnType<typeof JSON.parse> {
  try {
    return JSON.parse(text);
  } catch {
    return JSON.parse(jsonrepair(text));
  }
}
